import { Component, ErrorInfo } from "react";
import { AppMetricaProvider } from "./AppMetrica";
import { history } from "../Redux/Reducers/history";

class AppMetricaErrorBoundary extends Component {
  constructor(props: Component["props"]) {
    super(props);
    history.listen((loc) => {
      this.historyTrace.push(`${history.action} ${loc.pathname}`);
    });
  }

  historyTrace: string[] = [];

  handleUnhandledRejection = (event: PromiseRejectionEvent) => {
    AppMetricaProvider.reportError(event.reason.message, `${this.historyTrace.join("\n")}\n${event.reason.stack}`);
    event.preventDefault();
  };

  componentDidCatch(error: Error, info: ErrorInfo) {
    AppMetricaProvider.reportError(error.message, `${this.historyTrace.join("\n")}\n${error.stack}`);
  }

  componentDidMount(): void {
    window.addEventListener("unhandledrejection", this.handleUnhandledRejection);
  }

  componentWillUnmount(): void {
    window.removeEventListener("unhandledrejection", this.handleUnhandledRejection);
  }

  render() {
    return this.props.children;
  }
}

export { AppMetricaErrorBoundary };
